import {AxiosRequestConfig, AxiosResponse} from 'axios';
import Axios from '@/config/axios';

export default class ApiService {
  static setHeader(header: string, value: string | null) {
    if (value) {
      Axios.defaults.headers.common[header] = value;
    }
  }
  public static async get(url: string): Promise<any> {
    const response: AxiosResponse = await Axios.get(url);
    return response.data;
  }
  static async post<T>(url: string, api: T, config?: AxiosRequestConfig): Promise<any> {
    const response = await Axios.post(url, api, config);
    return response.data;
  }
  static async put(url: string, api?: any, config?: AxiosRequestConfig): Promise<any> {
    const response = await Axios.put(url, api, config);
    return response.data;
  }

  static delete(url: string): Promise<void> {
    return Axios.delete(url);
  }
}
